// Minimum/maximum profile thresholds shared across scraping providers and
// platforms. Enforced on the backend during handle validation and surfaced
// on the frontend in verification steps.
export const MIN_FOLLOWERS = 200;
export const MIN_POSTS = 5;
export const MAX_FOLLOWERS = 100000;
